import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import productItem from "./commodity/commodity.vue";
import waterfall from "./waterfall/waterfall.vue";
import Bus from "@/utils/bus";
import noImg from "@/assets/noimg.png";
import YYImage from '@/pages/design/components/basic/image';
import { mapState } from 'vuex';
export default {
  components: {
    productItem: productItem,
    waterfall: waterfall,
    YYImage: YYImage
  },
  props: {
    id: Number,
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    screenWidth: Number
  },
  data: function data() {
    return {
      //scroll高度
      defaultLangId: 0,
      noImg: noImg
    };
  },
  created: function created() {
    // let defaultLangObj = JSON.parse(localStorage.defaultLangObj);
    // if (defaultLangObj) {
    //   this.defaultLangId = defaultLangObj.langId;
    // }
    var defaultLangObjStr = localStorage.cdefaultLangObj ? localStorage.cdefaultLangObj : localStorage.defaultLangObj;
    var defaultLangObj = JSON.parse(defaultLangObjStr);
    if (defaultLangObj) {
      this.defaultLangId = defaultLangObj.langId;
    }
  },
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapState({
    imgHost: function imgHost(state) {
      return state.design.imgHost;
    }
  })), {}, {
    productList: function productList() {
      return this.data.productList;
    },
    spacing: function spacing() {
      return this.getPx(this.data.mBannerSpace);
    },
    moduleData: function moduleData() {
      var _this = this;
      // banner
      var tempBanner = [];
      // 18 为 banner之间的padding
      var padding = parseInt(this.data.mBannerSpace);
      var bannerWidth = (375 - (this.data.mHorizontalPadding || 0) * 2 - padding * (this.data.mBannerSizeNum - 1)) / this.data.mBannerSizeNum;
      this.data.pathlink.forEach(function (item) {
        tempBanner.push({
          style: {
            // 'background-image': 'url("'+ (this.imgHost + item.path) +'")',
            width: bannerWidth - padding + "px"
          },
          imgpath: item.path,
          styleSmall: {
            "background-image": 'url("' + item.path + '")',
            width: bannerWidth - padding * 2 + "px",
            height: _this.data.mBannerHeight + "px"
          },
          height: _this.data.mBannerHeight + "px",
          link: item.link,
          padding: padding / 2 + "px",
          outWidth: bannerWidth + "px"
        });
      });

      /* let pathlink = _.cloneDeep(this.formData.pathLink) */

      var arr = [];
      while (tempBanner.length > 0) {
        arr.push(tempBanner.splice(0, this.data.mBannerSizeNum));
      }
      return arr;
    },
    anchorPointImgItemStyle: function anchorPointImgItemStyle() {
      return function (key) {
        return {
          paddingTop: (key < this.data.mBannerSizeNum ? 0 : this.getPx(this.spacing)) + "px",
          paddingRight: ((key + 1) % this.data.mBannerSizeNum == 0 ? 0 : this.getPx(this.spacing)) + "px",
          height: this.data.mBannerHeight + "px",
          width: Math.floor((this.screenWidth - this.getPx(12) * 2 - this.getPx(this.spacing) * (this.data.mBannerSizeNum - 1)) / this.data.mBannerSizeNum) + "px"
        };
      };
    }
  }),
  methods: {
    goToPage: function goToPage() {},
    getPx: function getPx(pxValue) {
      var num = Math.floor(this.screenWidth / (375 / pxValue));
      return num;
    },
    //点击图片
    handleClick: function handleClick(link) {
      // window.location.href = link;
    },
    //跳转商品详情
    toProductDetails: function toProductDetails(proItem) {}
  }
};